/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { RESOURCE_TYPES } from "@adapptio/lib-core";

import { IEditor } from "../../IEditor";
import { registerCommands } from "./Commands";
import { registerKeyBindings } from "./KeyBindings";
import { registerMenus } from "./Menus";
import { EndpointEditorEditView } from "./EndpointEditorEdit/EndpointEditorEditView";
import { EndpointEditorEditMain } from "./EndpointEditorEdit/components/EndpointEditorEditMain";

export function EndpointEditorModule(dc: IEditor): void {
	dc.get("logger").debug("Endpoint editor module enabled.");

	const resourceSvc = dc.get("resourceService");
	const viewSvc = dc.get("viewService");

	viewSvc.registerView("endpointEditor.edit", EndpointEditorEditView, EndpointEditorEditMain);

	resourceSvc.registerResourceView(RESOURCE_TYPES.ENDPOINT, "endpointEditor.edit");
	resourceSvc.registerResourceCreateCommand(RESOURCE_TYPES.ENDPOINT, "endpointEditor.create.open");

	registerCommands(dc);
	registerKeyBindings(dc);
	registerMenus(dc);
}
